import {
  AppidFiltersResponse,
  ReleaseNumber,
} from './../home/appidfilters.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppidDataResponse } from '../home/appiddataresponse.model';
import { AccessToken, AuthUserInfo, StatusMsg } from '../newrequest/accesstoken';
import { FingerPrintDataResponse } from '../fingerprintid/fingerprintdataresponse.model';
import { customDetectorDataResponse } from '../custom-detector/custom-detector.model';

const header = new HttpHeaders().set('Access-Control-Allow-Origin', '*');

/*

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

*/

@Injectable({
  providedIn: 'root',
})
export class RestapiService {
  APP_ID_HOST: string;
  constructor(private http: HttpClient) {
    const hostname = window.location.hostname;

    console.log('Host Name : ' + hostname);

    if (hostname === 'localhost') {
      this.APP_ID_HOST = 'http://localhost:8081';
    } else if (hostname.indexOf('dev') !== -1) {
      this.APP_ID_HOST = 'https://appid-backend-api-dev.cisco.com/AppId';
    } else if (hostname.indexOf('stage') !== -1) {
      this.APP_ID_HOST = 'https://appid-backend-api-stg.cisco.com/AppId';
    } else {
      this.APP_ID_HOST = 'https://appid-backend-api-prod.cisco.com/AppId';
    }
  }

  getAppIdDataResponse(): Observable<HttpResponse<AppidDataResponse>> {
    return this.http.get<AppidDataResponse>(
      this.APP_ID_HOST + '/api/v1/appIdData',
      {
        observe: 'response',
        headers: header,
      }
    );
  }
  getAppIdFiltersResponse(
    appIdArr: any
  ): Observable<HttpResponse<AppidFiltersResponse>> {
    return this.http.post<AppidFiltersResponse>(
      this.APP_ID_HOST + '/api/v1/appIdSearchFilters',
      appIdArr,
      { observe: 'response', headers: header }
    );
  }

  getReleaseNumber(): Observable<HttpResponse<ReleaseNumber[]>> {
    return this.http.get<ReleaseNumber[]>(
      this.APP_ID_HOST + '/api/v1/getReleaseNumbers',
      { observe: 'response', headers: header }
    );
  }

  getReleaseNotes(releaseNumber: number): Observable<HttpResponse<string>> {
    return this.http.get<string>(
      this.APP_ID_HOST +
      '/api/v1/getReleaseNoteDetails?releaseNumber=' +
      releaseNumber,
      { observe: 'response', headers: header }
    );
  }

  submitNewDetectorRequest(formData: FormData): Observable<HttpResponse<any>> {
    const newHeader = new HttpHeaders()
      .set('processData', 'false')
      .set('mimeType', 'multipart/form-data')
      .set('contentType', 'false');
    return this.http.post<any>(
      this.APP_ID_HOST + '/api/v1/addNewDetectorRequest',
      formData,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
  }

  getReleaseAppDetails(
    appId: number
  ): Observable<HttpResponse<AppidDataResponse>> {
    return this.http.get<AppidDataResponse>(
      this.APP_ID_HOST + '/api/v1/getReleaseAppDetails?appId=' + appId,
      { observe: 'response', headers: header }
    );
  }

  getAuthCodeUrl(): Observable<HttpResponse<StatusMsg>> {
    return this.http.get<StatusMsg>(
      this.APP_ID_HOST + '/api/v1/getAuthCodeUrl',
      { observe: 'response', headers: header }
    );
  }
  getAccessTokenWithAuthCode(
    authCode: string
  ): Observable<HttpResponse<AccessToken>> {
    return this.http.get<AccessToken>(
      this.APP_ID_HOST + '/api/v1/getAccessTokenWithAuthCode?authCode=' + authCode,
      { observe: 'response', headers: header }
    );
  }
  getUserInfo(): Observable<HttpResponse<AuthUserInfo>> {
    return this.http.get<AuthUserInfo>(
      this.APP_ID_HOST + '/api/v1/getUserInfo?accessToken=' + localStorage.getItem('TOKEN'),
      { observe: 'response', headers: header }
    );
  }

  submitFeedBack(scaleCount : string,feedBackDescription:string,email:string,contactPerson:string): Observable<Object> {
    
    return this.http.post(
      this.APP_ID_HOST + "/api/v1/submitFeedBack", {
        scaleCount,feedBackDescription,email,contactPerson
    }, {
      headers: header
    });
    
  }

  getReleaseNumberForApp(application : string): Observable<HttpResponse<string>> {
    return this.http.get<string>(
      this.APP_ID_HOST + '/api/v1/getReleaseNumberForApplication?application='+application,
      { observe: 'response', headers: header }
    );
  }

  getReleaseNumberDates(): Observable<HttpResponse<string>> {
    return this.http.get<string>(
      this.APP_ID_HOST + '/api/v1/getReleaseNumberDates',
      { observe: 'response', headers: header }
    );
  }

  submitFingerPrintRequest(formData: FormData): Observable<HttpResponse<FingerPrintDataResponse>> {
    const newHeader = new HttpHeaders()
      .set('processData', 'false')
      .set('mimeType', 'multipart/form-data')
      .set('contentType', 'false');
    return this.http.post<HttpResponse<FingerPrintDataResponse>>(
      this.APP_ID_HOST + '/api/v1/getFingerPrintIdData',
      formData,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
  }

  submitRequest(formData: FormData): Observable<HttpResponse<String>> {
    const newHeader = new HttpHeaders()
      .set('processData', 'false')
      .set('mimeType', 'multipart/form-data')
      .set('contentType', 'false');
    return this.http.post<HttpResponse<String>>(
      this.APP_ID_HOST + '/api/v1/submitRequest',
      formData,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
  }

  getAuthCodeUrlForEve(): Observable<HttpResponse<StatusMsg>> {
    return this.http.get<StatusMsg>(
      this.APP_ID_HOST + '/api/v1/getAuthCodeUrlForEve',
      { observe: 'response', headers: header }
    );
  }
  getAccessTokenWithAuthCodeForEve(
    authCode: string
  ): Observable<HttpResponse<AccessToken>> {
    return this.http.get<AccessToken>(
      this.APP_ID_HOST + '/api/v1/getAccessTokenWithAuthCodeForEve?authCode=' + authCode,
      { observe: 'response', headers: header }
    );
  }

  getAuthCodeUrlForShowAllTags(): Observable<HttpResponse<StatusMsg>> {
    return this.http.get<StatusMsg>(
      this.APP_ID_HOST + '/api/v1/getAuthCodeUrlForShowAllTags',
      { observe: 'response', headers: header }
    );
  }
  getAccessTokenWithAuthCodeForShowAllTags(
    authCode: string
  ): Observable<HttpResponse<AccessToken>> {
    return this.http.get<AccessToken>(
      this.APP_ID_HOST + '/api/v1/getAccessTokenWithAuthCodeForShowAllTags?authCode=' + authCode,
      { observe: 'response', headers: header }
    );
  }

  submitCustomDetectorRequest(formData: FormData): Observable<HttpResponse<customDetectorDataResponse>> {
    const newHeader = new HttpHeaders()
      .set('processData', 'false')
      .set('mimeType', 'multipart/form-data')
      .set('contentType', 'false');
    return this.http.post<HttpResponse<customDetectorDataResponse>>(
      this.APP_ID_HOST + '/api/v1/getCustomDetectorData',
      formData,
      {
        headers: header,
      }
    );
  }

  getCustomDetectorDataForModification(formData: FormData): Observable<HttpResponse<customDetectorDataResponse>> {
    return this.http.post<HttpResponse<customDetectorDataResponse>>(
      this.APP_ID_HOST + '/api/v1/getCustomDetectorDataForModification',
      formData,
      {
        headers: header,
      }
    );
  }

}
